import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
    token: "",
    pagePermission: {},
    subscribeTokens: [],
    badlaRatePersist: [],
    badlaOrderPersist: [],
  },
  reducers: {
    updateUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    clearUser(state) {
      state.user = {};
      state.token = "";
      state.pagePermission = {};
      state.subscribeTokens = [];
      state.badlaRatePersist = [];
      state.badlaOrderPersist = [];
    },
    setPagePermissions(state, action) {
      state.pagePermission = action.payload;
    },
    setSubscribeTokens(state, action) {
      state.subscribeTokens = action.payload;
    },
    setBadlaRatePersist(state, action) {
      state.badlaRatePersist = action.payload;
    },
    setBadlaOrderPersist(state, action) {
      state.badlaOrderPersist = action.payload;
    },
  },
});

export const userAction = userSlice.actions;
export default userSlice;
